import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import { FaEdit, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import TableContainer from '../../common/Tablecontainer'; // 💡 Reuses your common logic

const MaterialType = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedMaterialId, setSelectedMaterialId] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [formData, setFormData] = useState({ materialname: '', status: 'A' });
    const [list, setList] = useState([]);
    const [loadingCards, setLoadingCards] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [mobilePage, setMobilePage] = useState(1);

    const pageSize = 10;
        const loadMaterialTypes = async (
        page = 1,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const res = await API.get(
                "material-type/",
                {
                    params: {
                        page,
                        search
                    }
                }
            );

            if (res.data.results) {

                setList(res.data.results);
                setTotalCount(res.data.count);

            } else {

                setList(res.data);
                setTotalCount(res.data.length);

            }

        } catch (err) {

            console.error(err);

            setList([]);
            setTotalCount(0);

        } finally {

            setLoadingCards(false);

        }

    };
    useEffect(() => {

        const timer = setTimeout(() => {

            loadMaterialTypes(
                mobilePage,
                searchQuery
            );

        },400);

        return ()=>clearTimeout(timer);

    },[
    mobilePage,
    searchQuery
    ]);
    const handleAddNewClick = (refreshTable) => {
        setFormData({ materialname: '', status: 'A' });
        setIsEditMode(false);
        setIsModalOpen(true);
        window.activeTableRefresh = refreshTable;
    };

    const openEditModalWindow = (item, refreshTable) => {
        setFormData({ materialname: item.materialname, status: item.status || 'A' });
        setSelectedMaterialId(item.materialid);
        setIsEditMode(true);
        setIsModalOpen(true);
        window.activeTableRefresh = refreshTable;
    };

    const handleFormSubmitAction = async (e) => {
        e.preventDefault();
        try {
            if (isEditMode) {
                await API.put(`material-type/${selectedMaterialId}/`, formData);
                toast.success("Updated successfully!");
            } else {
                await API.post('material-type/', formData);
                toast.success("Saved successfully!");
            }
            setIsModalOpen(false);

            await loadMaterialTypes(
                mobilePage,
                searchQuery
            );

            if(window.activeTableRefresh){

                window.activeTableRefresh();

            }
        } catch (err) {
            toast.error("Error saving data.");
        }
    };

    const handleRecordDeleteTrigger = async (pk, refreshTable) => {
        if (!window.confirm("Are you sure?")) return;
        try {
            await API.delete(`material-type/${pk}/`);
            toast.error("Deleted successfully!");
            await loadMaterialTypes(
                mobilePage,
                searchQuery
            );

            if(refreshTable){

                refreshTable();

            }
        } catch (err) {
            toast.error("Deletion failed.");
        }
    };
    const openAddModalWindow = (refreshTable) => {
        setFormData({ materialname: '', status: 'A' });
        setIsEditMode(false);
        setIsModalOpen(true);
        window.activeTableRefresh = refreshTable;
    };

    
    const gridHeaders = ['Material Description', 'Action'];

    return (
        <div className="p-3 sm:p-5 md:p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans">
            
            <div className="w-full max-w-6xl mx-auto flex flex-col space-y-4 px-2">
                
                {/* ─── BLOCK 1: PAGE HEADING ─── */}
                <div className="w-full  py-3.5 text-center rounded-lg ">
                    <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-light text-gray-700 mb-8 tracking-tight">
                        Material Type
                    </h2>
                </div>

                {/* ─── BLOCK 2: ACTION ROW (Add Button) ─── */}
                <div className="w-full px-2 py-2 flex justify-center md:justify-end">
                    <button 
                        type="button"
                        onClick={openAddModalWindow}
                        className="w-full md:w-auto bg-[#032167] text-white px-3 py-2 rounded text-xs font-semibold tracking-wide flex items-center gap-2 hover:bg-blue-950 transition-all border-none cursor-pointer active:scale-95"
                    >
                        <FaPlus size={10} /> Add New 
                    </button>
                </div>

                {/* ─── BLOCK 3: DATA TABLE ─── */}
                <div className="hidden md:block">
                <TableContainer
                    columns={gridHeaders}
                    apiUrl="material-type/"
                    
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery} 
                    searchPlaceholder="Search materials categories..."
                    renderRow={(item, index, srNo) => (
                        <tr key={item.materialid || index} className="border-b border-gray-200 hover:bg-gray-50 transition-colors h-[40px] text-gray-700 text-xs font-medium bg-white">
                            <td className="p-3 border-r bg-gray-50/50 font-bold text-gray-400 w-[8%] text-center">{srNo}</td>
                            <td className="p-3 border-r text-left pl-6 uppercase font-bold text-[#032167]">{item.materialname}</td>
                            
                            <td className="w-[12%] p-0">
                                <div className="flex items-center justify-center w-full h-[40px]">
                                    <div className="flex-1 flex justify-center items-center h-full border-r border-gray-200">
                                        <button onClick={() => openEditModalWindow(item)} className="text-[#5c9314] border-none bg-transparent cursor-pointer transition-all flex items-center justify-center w-full h-full">
                                            <FaEdit size={18} />
                                        </button>
                                    </div>
                                    <div className="flex-1 flex justify-center items-center h-full">
                                        <button onClick={() => handleRecordDeleteTrigger(item.materialid)} className="text-[#b0b7bd] hover:text-red-600 border-none bg-transparent cursor-pointer transition-all flex items-center justify-center w-full h-full">
                                            <FaTrash size={16} />
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    )}
                />
                </div>
                <div className="md:hidden mt-4">

                <input
                type="text"
                value={searchQuery}
                placeholder="Search Material..."
                onChange={(e)=>{

                setSearchQuery(e.target.value);

                setMobilePage(1);

                }}
                className="w-full border rounded-lg p-3 text-sm outline-none"
                />

                </div>

                <div className="md:hidden space-y-4 mt-4">

                {

                loadingCards

                ?

                <div className="text-center py-10">

                Loading...

                </div>

                :

                list.length===0

                ?

                <div className="text-center py-10">

                No Record Found

                </div>

                :

                list.map((item)=>(

                <div
                key={item.materialid}
                className="bg-white rounded-xl shadow border p-4">

                <div className="space-y-3">

                <div>

                <p className="text-xs text-gray-500">

                Material Description

                </p>

                <p className="font-bold text-[#032167]">

                {item.materialname}

                </p>

                </div>

                <div className="flex justify-end gap-4 pt-3 border-t">

                <button
                onClick={()=>
                openEditModalWindow(
                item,
                window.activeTableRefresh
                )
                }
                className="text-green-600">

                <FaEdit/>

                </button>

                <button
                onClick={()=>
                handleRecordDeleteTrigger(
                item.materialid,
                window.activeTableRefresh
                )
                }
                className="text-red-600">

                <FaTrash/>

                </button>

                </div>

                </div>

                </div>

                ))

                }

                </div>
                <div className="md:hidden flex justify-between items-center mt-5">

                <button
                disabled={mobilePage===1}
                onClick={()=>setMobilePage(p=>p-1)}
                className="px-4 py-2 border rounded disabled:opacity-40">

                Previous

                </button>

                <span>

                Page {mobilePage} of {Math.max(1,Math.ceil(totalCount/pageSize))}

                </span>

                <button
                disabled={
                mobilePage>=Math.max(
                1,
                Math.ceil(totalCount/pageSize)
                )
                }
                onClick={()=>setMobilePage(p=>p+1)}
                className="px-4 py-2 border rounded disabled:opacity-40">

                Next

                </button>

                </div>

            </div>

            {/* --- Add / Edit Form Modal Framework --- */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black/50 overflow-y-auto z-[4000]">

                    <div className="min-h-full flex items-center justify-center p-3 md:p-6">
                    <div className="bg-white w-full max-w-[95vw] sm:max-w-2xl rounded-lg shadow-2xl overflow-hidden relative border border-gray-300">
                        <div className="flex items-center justify-between p-3.5 border-b bg-[#032167]">
                            <h3 className="text-sm font-bold text-white uppercase tracking-wider">
                                {isEditMode ? 'Modify Material Type' : 'Append Fresh Material Type'}
                            </h3>
                            <button type="button" onClick={() => setIsModalOpen(false)} className="text-gray-500 hover:text-black border-none bg-transparent text-xl cursor-pointer font-bold">
                                <FaTimes size={16} />
                            </button>
                        </div>
                        <form onSubmit={handleFormSubmitAction} className="p-6 space-y-4 text-xs font-semibold uppercase text-gray-700">
                            <div className="flex flex-col space-y-1.5">
                                <label>Material Category Description <span className="text-red-500">*</span></label>
                                <input type="text" value={formData.materialname} onChange={(e) => setFormData({...formData, materialname: e.target.value})} placeholder="e.g. VIDEO, PDF, STUDY MATERIAL" className="p-2.5 border border-gray-300 rounded outline-none bg-gray-50 font-bold text-gray-800 normal-case" required />
                            </div>
                            <div className="flex flex-col space-y-1.5">
                                <label>Status</label>
                                <select value={formData.status} onChange={(e) => setFormData({...formData, status: e.target.value})} className="p-2.5 border border-gray-300 rounded outline-none bg-gray-50 font-bold">
                                    <option value="A">Active Permission</option>
                                    <option value="I">Inactive State</option>
                                </select>
                            </div>
                            <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4 border-t mt-6">
                                <button type="button" onClick={() => setIsModalOpen(false)} className="w-full sm:w-auto px-5 py-2 bg-gray-100 text-gray-700 rounded font-bold uppercase tracking-wider border hover:bg-gray-200 cursor-pointer">Cancel</button>
                                <button type="submit" className="w-full sm:w-auto px-6 py-2 bg-[#032167] text-white rounded font-bold uppercase tracking-wider hover:bg-blue-950 transition-all cursor-pointer border-none shadow-md">Save Material</button>
                            </div>
                        </form>
                    </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MaterialType;